import Cookies from 'js-cookie'
const state = {
  // 存储用户信息
  uniPcUser: Cookies.get('uniPcUser') ? Cookies.get('uniPcUser') : '',
  companyName: Cookies.get('companyName') ? Cookies.get('companyName') : '',
  unipc_companyMobile: Cookies.get('unipc_companyMobile') ? Cookies.get('unipc_companyMobile') : '',
  companyLogo: Cookies.get('companyLogo') ? Cookies.get('companyLogo') : '',
  uid: Cookies.get('uniPc_uid') ? Cookies.get('uniPc_uid') : '',
  uniPc_agency_id: Cookies.get('uniPc_agency_id') ? Cookies.get('uniPc_agency_id') : '',
  uniPc_avatar: Cookies.get('uniPc_avatar') ? Cookies.get('uniPc_avatar') : '',
  uniPc_isHeader: Cookies.get('uniPc_isHeader') ? Cookies.get('uniPc_isHeader') : '',
  uniPc_name: Cookies.get('uniPc_name') ? Cookies.get('uniPc_name') : ''
}
const mutations = {
  storageUser: (state, msg) => {
    state.uniPcUser = msg.uniPcUser
    Cookies.set('uniPcUser', msg.uniPcUser, { expires: 7 })
  },
  storageCompanyName: (state, msg) => {
    state.companyName = msg.companyName
    Cookies.set('companyName', msg.companyName, { expires: 7 })
  },
  storageCompanyMobile: (state, msg) => {
    state.unipc_companyMobile = msg.unipc_companyMobile
    Cookies.set('unipc_companyMobile', msg.unipc_companyMobile, { expires: 7 })
  },
  storageCompanyLogo: (state, msg) => {
    state.companyLogo = msg.companyLogo
    Cookies.set('companyLogo', msg.companyLogo, { expires: 7 })
  },
  storageUid: (state, msg) => {
    state.uid = msg.uid
    Cookies.set('uniPc_uid', msg.uid, { expires: 7 })
  },
  storageuniPc_agency_id: (state, msg) => {
    state.uniPc_agency_id = msg.uniPc_agency_id
    Cookies.set('uniPc_agency_id', msg.uniPc_agency_id, { expires: 7 })
  },
  storageUniPc_avatar: (state, msg) => {
    state.uniPc_avatar = msg.uniPc_avatar
    Cookies.set('uniPc_avatar', msg.uniPc_avatar, { expires: 7 })
  },
  storageuniPc_isHeader: (state, msg) => {
    state.uniPc_isHeader = msg.uniPc_isHeader
    Cookies.set('uniPc_isHeader', msg.uniPc_isHeader, { expires: 7 })
  },
  storageuniPc_name: (state, msg) => {
    state.uniPc_name = msg.uniPc_name
    Cookies.set('uniPc_name', msg.uniPc_name, { expires: 7 })
  }
}
const actions = {
  storageActionUser(context, info) {
    context.commit('storageUser', info)
  },
  actionCompany({ commit }, info) {
    commit('storageCompanyName', info)
  },
  actionCompanyMobile({ commit }, info) {
    commit('storageCompanyMobile', info)
  },
  actionCompanyLogo({ commit }, info) {
    commit('storageCompanyLogo', info)
  },
  actionUid({ commit }, info) {
    commit('storageUid', info)
  },
  actionuniPc_agency_id({ commit }, info) {
    commit('storageuniPc_agency_id', info)
  },
  actionUniPc_avatar({ commit }, info) {
    commit('storageUniPc_avatar', info)
  },
  actionuniPc_isHeader({ commit }, info) {
    commit('storageuniPc_isHeader', info)
  },
  actionuniPc_name({ commit }, info) {
    commit('storageuniPc_name', info)
  }
}
export default {
  namespaced: true,
  state,
  mutations,
  actions
}
